module.exports = __webpack_public_path__ + "static/media/imageArtur.296bc53a.jpeg";